import * as React from "react";
import {render} from "react-dom";
import {AppContainer} from "react-hot-loader";
import App from "./components/App";
import {number, object} from "prop-types";

let __svg__:{path:string,name:string,filename?:string} = { path: './assets/img/*.svg', name: './sprite.svg' };
__svg__.filename = './assets/sprite.svg';
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

const rootEl = document.getElementById("root");

let answers=[
    [
        {'n':'9 899','y':'265 300'},
        {'y':'60','n':'60 000'},
        {'n':'87 000','y':'24 000'},
        {'n':'98 650','y':'19 700'},
        {'y':'78 000','n':'243'},
    ],
    [
        {'y':'78 000','n':'243'},
        {'n':'990','y':'24 000'},
        {'n':'63 370','y':'2 090'},
        {'n':'22 370','y':'2 370'},
        {'n':'3 480','y':'53 000'},
    ],
    [
        {'n':'87 000','y':'24 000'},
        {'n':'9 899','y':'265 300'},
        {'n':'22 370','y':'2 370'},
        {'n':'98 650','y':'19 700'},
        {'n':'990','y':'24 000'},
    ]
    ];
let videos:{'y':string,'n':string}[][] = [
    [
        {'n':'','y':'PJtSccjFbb8'},
        {'n':'4RMd8afg5Ak','y':'GHz0_Q1h3Jc'},
        {'n':'JrNZ4kUhLuU','y':'xefN8B0r5s4'},
        {'n':'oL13k8wWjRw','y':'Zhkn_v4yN9I'},
        {'n':'af41XuL6GSc','y':'6UI0s6Ib1Ts'},
    ],
    [
        {'n':'','y':'DIELvfx6oyI'},
        {'n':'pXZmlUXIu3I','y':'tbVfOP3EJsU'},
        {'n':'DRG0yy3X4Sw','y':'aAdRe6AhKds'},
        {'n':'AHW5ogirT0M','y':'WyxcpWODz3g'},
        {'n':'No29NaIdKyk','y':'nRKdNtR7rAI'}
    ],
    [
        {'n':'','y':'_8YT2kZu_qk'},
        {'n':'z7ZFO8Xcuu0','y':'MHLZsI-N5hc'},
        {'n':'FZGwbmi-5vQ','y':'bckdE_mVhvk'},
        {'n':'LGM-iXRJyf0','y':'Q_wefiNe2TY'},
        {'n':'CCmgSttZzm0','y':'T7KEWcJfe_w'}
    ]
];
let results:{'y':string,'n':string}[][] = [
    [
        {'n':'Qc1cqxSra_Y','y':'D74PXpQBjJI'},
        {'n':'2ty7AoZ6jgo','y':'4bgl5af1aOA'},
        {'n':'KRyl7iEe9rE','y':'dtfbcOue3zc'}
    ],
    [
        {'n':'R4VQjZ8slKw','y':'KB9v_UXgwFc'},
        {'n':'iz1nO3cbCXg','y':'pGVcx-8Yjlc'},
        {'n':'wbMjrVQ-OUI','y':'jBLddx-gZ4c'}
    ],
    [
        {'n':'QgLc454cgkU','y':'E0wSvXSB9DI'},
        {'n':'PFAm_08Nrnw','y':'w9F4JY0vOBQ'},
        {'n':'7R_AxTQ1a10','y':'AqMw55MQBmE'}
    ]
];
let testNumber:number=Math.floor(Math.random() * 3);
render(
    <AppContainer>
        <App answers={answers[testNumber]} videos={videos[testNumber]} results={results[testNumber]} />
    </AppContainer>,
    rootEl
);

// Hot Module Replacement API
declare let module: { hot: any };

if (module.hot) {
    module.hot.accept("./components/App", () => {
        const NewApp = require("./components/App").default;

        render(
            <AppContainer>
                <NewApp/>
            </AppContainer>,
            rootEl
        );
    });
}
